import { useState } from 'react';
import { Box, Button, Input, Stack } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import AuthHeader from '@/components/auth-header';
import { Field } from '@/components/ui/field';

// SSOStart asks for the workspace key, then full-page redirects to the backend
// SSO login endpoint, which in turn 302s to the customer's identity provider.
const SSOStart = () => {
  const [slug, setSlug] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = slug.trim();
    if (!trimmed) return;
    setSubmitting(true);
    window.location.href = `${import.meta.env.VITE_API_URL}/auth/sso/${encodeURIComponent(
      trimmed,
    )}/login`;
  };

  return (
    <Stack gap={6}>
      <AuthHeader title='Single sign-on' />
      <form onSubmit={onSubmit}>
        <Stack gap={4}>
          <Field
            label='Workspace key'
            helperText='Enter your organization’s workspace key to continue to your identity provider.'
          >
            <Input
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              placeholder='e.g. acme'
              autoFocus
            />
          </Field>
          <Button type='submit' width='full' loading={submitting} loadingText='Redirecting...'>
            Continue with SSO
          </Button>
        </Stack>
      </form>
      <Box textAlign='center'>
        <Button fontSize='sm' variant='ghost' asChild>
          <NavLink to='/auth/login'>Back to login</NavLink>
        </Button>
      </Box>
    </Stack>
  );
};

export default SSOStart;
